<div class="cm-item-dropdown">
  <div
    class="cm-item-dropdown__trigger"
    [class.cm-item-dropdown__trigger--disabled]="disabled()"
    [attr.aut-id]="autId()"
  >
    <div class="cm-item-dropdown__content">
      <ng-content></ng-content>
    </div>

    <cm-select-field
      [options]="selectOptions()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [loading]="loading()"
      [autId]="autId() + '-select'"
      [ariaLabel]="ariaLabel() || placeholder()"
      [hideLabel]="true"
      [hideErrors]="true"
      [(ngModel)]="selectedValue"
      (ngModelChange)="onSelectChange($event)"
      (openedChange)="onOpenedChange($event)"
    />
  </div>
</div>
